export default "__VITE_ASSET__d1fa4aaa__"